import moment from 'moment-timezone';

import { setOrm } from 'common-src/features/orm';
import orm from 'common-src/orm';

import { store } from 'src/store';

import DashboardV2Appointment from './DashboardV2Appointment';

const getBrowserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

const getLocalizedAppointmentDateTime = (appointment) => {
  const appointmentDate = appointment?.date ?? null;
  const appointmentTime = appointment?.time ?? null;
  if (!appointmentDate || !appointmentTime) {
    return {
      date: appointmentDate,
      time: appointmentTime,
    };
  }

  const appointmentDateTime = moment.utc(
    `${appointmentDate} ${appointmentTime}`,
    ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'],
    true,
  );

  if (!appointmentDateTime.isValid()) {
    return {
      date: appointmentDate,
      time: appointmentTime,
    };
  }

  const localizedDateTime = appointmentDateTime.tz(getBrowserTimeZone());

  return {
    date: localizedDateTime.format('YYYY-MM-DD'),
    time: localizedDateTime.format('HH:mm'),
  };
};

export const normalizeAppointment = (appointment) => {
  const patient = appointment?.patient || {};
  const { date, time } = getLocalizedAppointmentDateTime(appointment);

  return {
    id: appointment.id,
    patientId:
      appointment.patientId ?? appointment.patient_id ?? patient.patientId ?? patient.patient_id,
    patient,
    workflowInstanceId: appointment.workflowInstanceId ?? appointment.workflow_instance_id ?? null,
    workflowDueAt: appointment.workflowDueAt ?? appointment.workflow_due_at ?? null,
    departmentAthenaId: appointment.departmentAthenaId ?? appointment.department_athena_id ?? null,
    providerAthenaId: appointment.providerAthenaId ?? appointment.provider_athena_id ?? null,
    date,
    time,
    departmentLocalDate: appointment.departmentLocalDate ?? null,
    departmentLocalTime: appointment.departmentLocalTime ?? null,
    departmentTimezone: appointment.departmentTimezone ?? null,
    visitType: appointment.visitType ?? appointment.visit_type,
    appointmentTypeId: appointment.appointmentTypeId ?? null,
    durationMinutes: appointment.durationMinutes ?? null,
    clinician: appointment.clinician ?? null,
    location: appointment.location ?? null,
    noteUrl: appointment.noteUrl ?? appointment.note_url ?? null,
    athenaScheduleNote: appointment.athenaScheduleNote ?? null,
    latestMoca: appointment.latestMoca ?? null,
    readiness: appointment.readiness || {},
    tasks: appointment.tasks || [],
  };
};

export const syncDashboardV2Appointments = (responseBody) => {
  const appointments = responseBody?.data || [];
  const rootOrm = store.getState().orm;
  const session = orm.session(rootOrm);
  const modelClass = session[DashboardV2Appointment.modelName];

  modelClass.all().delete();
  appointments.forEach((appointment) => {
    modelClass.upsert(normalizeAppointment(appointment));
  });

  store.dispatch(setOrm(session.state));
};
